import { useWSMutation, WSMutationsConfig } from "@ws-react-query";
import { WSServiceError } from "../../utils/serviceHelper";
import { QUERY_BENEFITS_PLAN_ENROLLMENT } from "./usePlanEnrollment";
import { QUERY_BENEFITS_PLAN_ENROLLMENTS } from "./usePlanEnrollments";
import { createPlanEnrollment } from "../../services/api/planEnrollment/createPlanEnrollment";
import {
  IPlanEnrollment,
  IPlanEnrollmentCreateRequest
} from "../../services/api/planEnrollment/types";
import { REQUIREMENTS_DEPENDENCIES } from "../../modules/Requirements/dependencies";

export const useCreatePlanEnrollment = (
  config?: WSMutationsConfig<
    IPlanEnrollment,
    WSServiceError,
    IPlanEnrollmentCreateRequest
  >
) =>
  useWSMutation(
    (request: IPlanEnrollmentCreateRequest) => createPlanEnrollment(request),
    {
      dependencies: [
        QUERY_BENEFITS_PLAN_ENROLLMENT,
        QUERY_BENEFITS_PLAN_ENROLLMENTS,
        ...REQUIREMENTS_DEPENDENCIES
      ],
      ...config
    }
  );
